export default __webpack_public_path__ + "static/media/chicken-wing-640w.1885eaa0.jpg";